import { Reveal } from "./Reveal";
import { mailtoHref } from "../data/site";

export const FinalCTA = () => {
    return (
        <section
            data-testid="final-cta"
            className="bg-[#111111] text-white relative overflow-hidden"
        >
            <div className="absolute inset-0 grid-lines-fine opacity-30 pointer-events-none" />
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-28 md:py-40 relative">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-2 hidden md:block">
                        <p className="eyebrow text-white/60">§ 11</p>
                    </div>
                    <div className="md:col-span-10">
                        <Reveal>
                            <p className="eyebrow text-white/60 md:hidden mb-4">
                                Final word
                            </p>
                            <h2 className="font-serif text-[44px] sm:text-6xl md:text-7xl leading-[1.02] tracking-tight">
                                Your digital presence is often
                                <br />
                                your first impression.{" "}
                                <em className="text-white/70">
                                    Make it count.
                                </em>
                            </h2>
                        </Reveal>

                        <Reveal delay={0.1}>
                            <p className="mt-10 text-white/70 text-lg max-w-xl leading-relaxed">
                                Build trust. Generate enquiries. Support
                                growth. One quiet conversation is usually
                                enough to know whether we’re the right fit.
                            </p>
                        </Reveal>

                        <Reveal delay={0.2}>
                            <div className="mt-12 flex flex-wrap items-center gap-4">
                                <a
                                    href={mailtoHref(
                                        "Strategy call enquiry from Pixemance",
                                    )}
                                    data-testid="final-cta-email"
                                    className="inline-flex items-center gap-3 bg-white text-[#111111] px-8 py-4 text-[13px] tracking-wide font-medium hover:bg-[#dddddd] transition-colors duration-300 group"
                                >
                                    Talk to Pixemance
                                    <span
                                        aria-hidden
                                        className="transition-transform duration-500 group-hover:translate-x-1"
                                    >
                                        →
                                    </span>
                                </a>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
};
